import moment, { Moment } from 'moment/moment'

export interface ClubProductPayload {
    id: number
    name: string
    manufacturer: string
    description: string
    photo_url: string
    photos: string[]
    link: string
    link_text: string
    link_params?: {}
    metadata?: {}
    enabled?: boolean
    created_at: string
    translations?: {}
}

export class ClubProduct {

    id: number
    name: string
    manufacturer: string
    description: string
    photoUrl: string
    photo?: File
    photos: string[] = []
    photoUps?: File[]
    link: string
    linkText: string
    linkParams?: {} = <any>{}
    metadata?: {} = <any>{}
    enabled: boolean
    createdAt: Moment
    translations?: {} = <any>{}

    constructor(data: ClubProductPayload) {
        this.id = data.id
        this.name = data.name
        this.manufacturer = data.manufacturer
        this.description = data.description
        this.photoUrl = data.photo_url
        this.photos = data.photos || []
        this.link = data.link
        this.linkText = data.link_text
        this.enabled = !! data.enabled
        this.createdAt = moment(data.created_at)
        this.capture(data)
    }

    fill(data: ClubProductPayload): this {
        this.id = data.id
        this.name = data.name
        this.manufacturer = data.manufacturer
        this.description = data.description
        this.photoUrl = data.photo_url
        this.photos = data.photos || []
        this.link = data.link
        this.linkText = data.link_text
        this.enabled = !! data.enabled
        this.createdAt = moment(data.created_at)
        this.capture(data)
        return this
    }

    capture(data: ClubProductPayload): this {
        if (data.link_params) {
            this.linkParams = data.link_params
        }
        if (data.metadata) {
            this.metadata = data.metadata
        }
        if (data.translations) {
            this.translations = data.translations
        }
        return this
    }

    delPhoto(number: number): this {
        const photos = this.photos.map(i => JSON.parse(JSON.stringify(i)))
        photos.splice(number, 1)
        this.photos = []
        photos.map(i => this.photos.push(i))
        return this
    }

    updatePhotoNumber(currentNumber: number, number: number): this {
        const set = JSON.parse(JSON.stringify(this.photos[currentNumber]))
        this.photos.splice(currentNumber, 1)
        const photos = this.photos.map(i => JSON.parse(JSON.stringify(i)))
        photos.splice(number, 0, set)
        this.photos = []
        photos.map(i => this.photos.push(i))
        return this
    }

    exists(): boolean {
        return !! this.id
    }

    unset(): void {
        this.fill(<any>{})
        this.photo = undefined
        this.photoUps = undefined
        this.photos = []
        this.linkParams = {}
        this.metadata = {}
        this.translations = {}
    }

    payload(): ClubProductPayload | any {
        return {
            id: this.id,
            name: this.name,
            manufacturer: this.manufacturer,
            description: this.description,
            photos: this.photos,
            link_text: this.linkText,
            link_params: this.linkParams,
            metadata: this.metadata,
            enabled: this.enabled,
            translations: this.translations,
        }
    }
}
